<template>
  <div class="grid-view">
    <div class="main-content">
      <search-bar ref="searchBar" config-module="3300001" :filter="searchConditions" :show-input-val="false" :ocr-tab="OCR_TAB_PENDING.code" @toQuery="toQuery" @supplementaryInformation="supplementaryInformation" @batchDelete="batchDelete" @change="searchChange" />
      <!--      <el-button v-if="$checkPermission(['button_ocrRecognition_supplementaryInformation'])" type="primary" style="width: 120px" @click="()=>supplementaryInformation()">{{ $t('CargoMsg.Cargo_SupplementaryInformation') }}</el-button>-->
      <div class="section grid-wrapper">
        <intelligent-booking-table
          ref="intelligentBookingTable"
          :row-data="rowData"
          config-module="3300021"
          tab-type="tabPending"
          @showDetails="(e)=>this.$emit('showDetails',e)"
          @refresh="fetchData"
          @changeSelected="changeSelected"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="intelligent-tab-pending"
          :total="searchConditions.total"
          :page.sync="searchConditions.pageNum"
          :limit.sync="searchConditions.pageSize"
          @pagination="queryPageHandler"
        />
      </div>
    </div>
  </div>
</template>

<script>
import IntelligentBookingTable from '@/views/cargo/v0/ToolAssistant/ocr/components/IntelligentBookingTable'
import DropUploader from '@/components/Cargo/Common/DropUploader'
import { getLoading } from '@/utils/utilBaseElement'
import {
  advancedQueryIntelligentDocument,
  batchRemoveIntelligentDocument
} from '@/api/seaExport/intelligentBooking'
import URL from '@/api/urlTranslator'
import SearchBar from '@/views/cargo/v0/ToolAssistant/ocr/components/SearchBar'
import {
  OCR_TAB_PENDING, SENDING_0,
  SENDING_CWMI,
  UPLOAD_STATUS_PARSE_DONE, UPLOAD_STATUS_PARSE_PROGRESS
} from '@/class/cargo/model/parameters/SystemConstants'
import { recordSelectedStatus } from '@/utils/agGrid'

export default {
  name: 'TabPending',
  components: { SearchBar, DropUploader, IntelligentBookingTable },
  props: {
    activeTabName: {
      type: String,
      default: () => ''
    },
    source: { // 来源【0-海出 1-远程订舱-海运】
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      URL,
      fileFormat: null,
      searchConditions: {
        total: 0,
        iType: -1,
        pageNum: 1,
        pageSize: 50,
        status: [0, 1, 2]
      },
      rowData: [],
      uploadParams: {},
      loading: false,
      timer: null,
      selectedRows: [],
      OCR_TAB_PENDING
    }
  },
  watch: {
    activeTabName(val, oldVal) {
      if (val && val !== oldVal && val === 'tabPending' && !this.timer) {
        this.fetchData(false)
      } else {
        this.cleanTimer()
      }
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    this.cleanTimer()
  },
  methods: {
    init() {
      this.fileFormat = '.pdf,.xls,.xlsx,.doc,.docx,.jpg,.gif,.png,.tif'
      this.fetchData(false)
    },
    fetchData(silent = true) {
      console.log('fetchPending')
      if (!silent) {
        this.loading = getLoading()
      }
      if (this.timer) {
        this.cleanTimer()
      }
      // 走高级查询
      // if (this.$refs.searchBar) {
      //   this.searchConditions.iType = this.$refs.searchBar.recognitionType
      // } else {
      //   this.searchConditions.iType = 0
      // }
      // const selectedStatus = recordSelectedStatus(this.$refs.intelligentBookingTable.gridApi, 'uuid')
      advancedQueryIntelligentDocument(this.searchConditions).then(res => {
        const { data } = res
        this.searchConditions.total = Number(data.total)
        this.searchConditions.pageNum = data.pageNum
        this.searchConditions.pageSize = data.pageSize
        if (silent) {
          // 将【解析中】的数据进行赋值（解决闪屏的问题）
          if (data.list && data.list.length > 0 && this.rowData && this.rowData.length > 0) {
            const dataMap = new Map()
            data.list.forEach(item => {
              dataMap[item.uuid] = item
            })
            const deleteRows = []
            const existUuids = []
            for (let i = 0; i < this.rowData.length; ++i) {
              const item = this.rowData[i]
              const dataItem = dataMap[item.uuid]
              if (!dataItem) {
                deleteRows.push(item)
                continue
              }
              existUuids.push(item.uuid)
              if (UPLOAD_STATUS_PARSE_PROGRESS.code === item.status) {
                item.status = dataItem.status
                item.analysisCompleteDate = dataItem.analysisCompleteDate
                item.resultJson = dataItem.resultJson
              }
            }
            // 删除
            if (deleteRows.length > 0) {
              // this.rowData.splice(index, 1)
              this.$refs.intelligentBookingTable.gridApi.updateRowData({ remove: deleteRows })
            }
            // 新增
            const addRows = data.list.filter(p => existUuids.indexOf(p.uuid) < 0)
            if (addRows.length > 0) {
              this.$refs.intelligentBookingTable.gridApi.updateRowData({ add: addRows })
            }
            this.$refs.intelligentBookingTable.gridApi.refreshCells({ force: true })
            return
          }
        }
        this.rowData = data.list
        this.selectedRows = []
      }).finally(() => {
        if (!silent) {
          !this.loading || this.loading.close()
        }
        this.setTimer()
      })
    },
    queryPageHandler() {
      this.fetchData(false)
    },
    uploadEnd() {
      this.fetchData(false)
    },
    triggerUpload() {
      this.$refs.dropUploader.triggeFileSelectWindow()
    },
    setTimer() {
      console.log('setTimer')
      this.timer = setTimeout(() => {
        this.fetchData()
      }, 10000)
    },
    cleanTimer() {
      clearTimeout(this.timer)
      this.timer = null
    },
    searchChange(e) {
      console.log(e)
      const params = this.searchConditions
      params.pageNum = 1
      switch (e.type) {
        case 'input':
          params.fileName = e.value
          break
        case 'select':
          this.searchConditions.iType = e.value
          break
        default:
          if (e.value) {
            params.days = e.value
          }
          params.fileName = ''
          break
      }
      this.fetchData(params)
    },
    toQuery() {
      this.fetchData(false)
    },
    changeSelected(list) {
      this.selectedRows = list
    },
    // 补充信息
    supplementaryInformation() {
      let selectedRows = this.selectedRows
      if (!selectedRows || selectedRows.length === 0) {
        // 未选中，则默认处理所有【解析完成】的【cwmi】的【海出托书】
        selectedRows = this.rowData.filter(item => item.status === UPLOAD_STATUS_PARSE_DONE.code &&
          item.identificationChannel === SENDING_CWMI.code && item.identificationType === SENDING_0.code)
        if (!selectedRows || selectedRows.length === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_NoNeedSupplementaryInformationBookNote'))
          return
        }
      } else {
        for (var item of selectedRows) {
          if (item.status !== UPLOAD_STATUS_PARSE_DONE.code ||
          item.identificationChannel !== SENDING_CWMI.code ||
          item.identificationType !== SENDING_0.code) {
            this.$message.warning(this.$t('CargoMsg.Cargo_SupplementaryInformationTip'))
            return
          }
        }
      }
      this.$emit('supplementaryInformation', { from: this.tabType, selectedRows: selectedRows })
    },
    // 批量删除
    batchDelete() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseSelectOneEntry'))
        return
      }

      const uuids = this.selectedRows.map((row) => {
        return row.uuid
      })
      this.$confirm(this.$t('CargoMsg.Cargo_DeleteBookingNote', [uuids.length]), this.$t('SeaExport.Tips'), {}).then(() => {
        const loading = getLoading()
        batchRemoveIntelligentDocument(uuids).then(res => {
          this.$message.success(this.$t('Message.DeleteSuccessfully'))
          this.fetchData(false)
        }).finally(() => loading.close())
      })
    }
  }
}
</script>

<style scoped>

</style>
